import { Badge } from '@chakra-ui/react';
import React from 'react';
import RequestState from "../../utils/RequestState";

interface RequestStateBadgeProps {
    requestState: string;
    marginTop?: number
}

const RequestStateBadge: React.FC<RequestStateBadgeProps> = (props) => {

    let badgeColorScheme : string = 'grey';

    switch (props.requestState)
    {
        case RequestState.Active:
            badgeColorScheme = 'green';
            break;

        case RequestState.Vacations:
            badgeColorScheme = 'yellow';
            break;

        case RequestState.Exit:
            badgeColorScheme = 'red';
            break;

        case RequestState.Reserve:
            badgeColorScheme = 'blue';
            break;

        default:
            break;
    }

    return (
        <Badge marginTop={props.marginTop} colorScheme={badgeColorScheme}>{props.requestState}</Badge>
    );
};

export default RequestStateBadge;